export default __webpack_public_path__ + "static/media/Geography01_07.25d3e892.png";